














import { defineComponent, onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import { ValidationProvider as VeeValidationProvider } from "vee-validate";

export default defineComponent({
  name: "ValidationProvider",
  components: { VeeValidationProvider },
  props: {
    rulesMessages: { type: Object, default: () => ({}) },
    validationMode: {
      type: String,
      validator: (value: string): boolean =>
        ["aggressive", "passive", "lazy", "eager"].includes(value) || value === undefined,
    },
    rules: {
      type: ([Array, Object, String] as any) as () => string[] | string | Record<string, any>,
      default: (): string[] => [],
    },
    name: { type: String, required: true },
  },
  setup(props, { emit }) {
    const validator = ref<InstanceType<typeof VeeValidationProvider>>();
    let unWatch: Function | undefined;
    onMounted(() => {
      unWatch = validator.value?.$watch(
        "flags.valid",
        newData => {
          emit("validation", newData);
        },
        {
          immediate: true,
        }
      );
    });
    onBeforeUnmount(() => unWatch && unWatch());

    return {
      validator,
    };
  },
});
